import { api } from 'boot/axios'
import { Notify } from 'quasar'

class BaseApi {
  static getErrorMessage(error) {
    if (!jng.isObject(error)) {
      return error
    }
    if (jng.isUndefined(error.response)) {
      console.error(error)
    }
    if (error.code == 'ECONNABORTED') {
      return error.message
    }
    if (error.response.status === 504) {
      let msg = 'There is connection to the server. Please check whether you can access different web site. If it is, please contact the Admin'
      // let msg = 'Tidak terkoneksi dengan server di internet. Cek apakah anda bisa mengakses alamat web lain. Apabila bisa, hubungi Admin.'
      return msg
    } else if (jng.isDefined(error.response.data)) {
      if (error.response.data instanceof ArrayBuffer) {
        let jsonMsg = ''
        var dataView = new DataView(error.response.data)
        for (let byteIdx = 0; byteIdx < dataView.byteLength; byteIdx++) {
          let c = dataView.getInt8(byteIdx)
          jsonMsg += String.fromCharCode(c)
        }
        return JSON.parse(jsonMsg).message
      } else {
        return error.response.data.message
      }
    } else {
      return error.response.message
    }
  }
  static showError(error) {
    Notify.create({message: BaseApi.getErrorMessage(error), color: 'red'})
    
  }

  static processError(error, onError, reject) {
    if (onError) {
      if (jng.isFunction(onError)) {
        onError({err: error, message: BaseApi.getErrorMessage(error)})
      } else {
        onError.isShow = true
        onError.type = 'error'
        onError.messages.push(BaseApi.getErrorMessage(error))
      }
    } else {
      if (reject) {
        let msg = 'Other error'
        if (jng.isObject(error)) {
          msg = BaseApi.getErrorMessage(error)
        }
        reject({ message: msg, err: error })
      }

    }
  }

  static processSuccess(response, onSuccess, resolve) {
    if (onSuccess) {
      onSuccess(response.data)
    }
    resolve(response.data)
  }


  static post(url, data, onSuccess, onError) {
    let concatUrl = this._constructUrl(url)
    return new Promise((resolve, reject) => {
      api.post(concatUrl, data)
        .then(function (response) {
          BaseApi.processSuccess(response, onSuccess, resolve)
        }).catch(function (error) {
          BaseApi.processError(error, onError, reject)
        });
    })
  }

  static postAsOctetStream(url, data, offset, onSuccess, onError) {
    let concatUrl = this._constructUrl(url)
    return new Promise((resolve, reject) => {
      api.post(concatUrl, data, {
            headers: {
                'Content-Type': 'application/octet-stream',
                'X-Chunk-Offset': offset
            }
        })
        .then(function (response) {
          BaseApi.processSuccess(response, onSuccess, resolve)
        }).catch(function (error) {
          BaseApi.processError(error, onError, reject)
        });
    })
  }


  static get(url, data, onSuccess, onError) {
    var concatUrl, dateProp, noError = false;
    if (jng.isDefined(data.length)) {
      //data is array 
      concatUrl = this._constructUrl(url, data);
    } else {
      //data is object
      var param = data;
      concatUrl = this._constructUrl(url, param.data);
      dateProp = param.dateProp;
      noError = param.noError;
    }
    var offset = new Date().getTimezoneOffset();
    var options = {
      method: 'get',
      url: concatUrl,
      headers: {
        'Timezone-Min': offset
      }
    };

    return new Promise((resolve, reject) => {
      api(options)
        .then(function (response) {
          if (jng.isDefined(dateProp)) {
            Date.setToDate(response.data, dateProp);
          }
          BaseApi.processSuccess(response, onSuccess, resolve)
        }).catch(function (error) {
          BaseApi.processError(error, onError, reject)
        });
    })
  }

  static _constructUrl(url, data) {
    let apiBase = jng.context.getApiBase()
    let api = ''
    if (!apiBase) {
      let baseUrl = window.location.origin + window.location.pathname.replace('student/', '') 
      jng.context.setApiBase(baseUrl)  
      api = baseUrl
    } else {
      api = apiBase.data.base
    }
    if (jng.isUndefined(data)) {
      return api.concatUrl(['api', url])
    }
    return api.concatUrl(['api', url]).concatUrl(data)
  }

  static delete(url, data, onSuccess, onError) {
    let concatUrl = this._constructUrl(url, data)
    return new Promise((resolve, reject) => {
      api.delete(concatUrl)
        .then(function (response) {
          BaseApi.processSuccess(response, onSuccess, resolve)
        }).catch(function (error) {
          BaseApi.processError(error, onError, reject)
        });
    })

  }


  static getFile(url, data, onSuccess, onError) {
    var offset = new Date().getTimezoneOffset();
    let concatUrl = this._constructUrl(url, data)
    return api.get(concatUrl,{
      responseType: 'arraybuffer',
      timeout: 15 * 60000,
      headers: {
        'Timezone-Min': offset
      }
    })
      .then(function(response) {
        
        var type = response.headers['Content-Type'];
        var fileName = BaseApi.getFileNameFromHeader(response);
        var file = new Blob([response.data], {type: type});

        BaseApi.saveAs(file, fileName);
        
        onSuccess(response.data)
      }).catch(function(error) {
        if (onError) {
          onError(error)
        } else {
          BaseApi.showError(error)
        }
      });
  }
  
  static getFileAsPost(url, data, onSuccess, onError) {
    let concatUrl = this._constructUrl(url)
    var offset = new Date().getTimezoneOffset();
    return api.post(concatUrl, data, {
      responseType: 'arraybuffer',
      timeout: 60 * 60000,
      headers: {
        'Timezone-Min': offset
      }
    })
      .then(function(response) {
        
        var type = response.headers['Content-Type'];
        var fileName = BaseApi.getFileNameFromHeader(response);
        var file = new Blob([response.data], {type: type});

        BaseApi.saveAs(file, fileName);
        
        onSuccess(response.data)
      }).catch(function(error) {
        if (onError) {
          onError(error)
        } else {
          BaseApi.showError(error)
        }
      });
  }

  static getFileNameFromHeader(response) {
    var disposition = response.headers["content-disposition"];
    var idxfileName = disposition.indexOf("filename")
    var fileName = disposition.substr(idxfileName);
    idxfileName = fileName.indexOf("=");
    fileName = fileName.substr(idxfileName + 1).trim();
    return fileName;
  }  

  static saveAs(blob, fileName) {
    var url = window.URL.createObjectURL(blob);

    var anchorElem = document.createElement("a");
    anchorElem.style = "display: none";
    anchorElem.href = url;
    anchorElem.download = fileName;

    document.body.appendChild(anchorElem);
    anchorElem.click();

    document.body.removeChild(anchorElem);

    setTimeout(function() {
        window.URL.revokeObjectURL(url);
    }, 1000);
  }  
}

export default BaseApi;